import React from 'react';
import { InputBar } from '@xingternal/text-field';
import { IconSearch } from '@xingternal/icons';

import styles from './SearchBar.css';

type SearchBarProps = {
  value: string;
  onChange: (val: string) => void;
  placeholder: string;
};

const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.searchIcon}>
        <IconSearch width="16" height="16" />
      </div>
      <div className={styles.input}>
        <InputBar
          skin={{ inputBar: styles.inputBar }}
          placeholder={placeholder}
          onKeyDown={(e: KeyboardEvent) => {
            e.stopPropagation();
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
            onChange(e.target.value);
          }}
          value={value}
        />
      </div>
    </div>
  );
};

export { SearchBar };
